import { render, staticRenderFns } from "./hzhb.vue?vue&type=template&id=fba910b6&scoped=true"
import script from "./hzhb.vue?vue&type=script&lang=js"
export * from "./hzhb.vue?vue&type=script&lang=js"
import style0 from "./hzhb.vue?vue&type=style&index=0&id=fba910b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba910b6",
  null
  
)

export default component.exports